var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ECharts',{style:({ height: _vm.height }),attrs:{"options":_vm.options,"auto-resize":"","watchShallow":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }